"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CREDENTIAL_POLICY = void 0;
exports.DEFAULT_CREDENTIAL_POLICY = {
    isAllowVulnerable: false,
    minLength: 10,
    minKindLength: 4,
    isRequireNumber: false,
    isRequireLower: false,
    isRequireUpper: false,
    isRequireSymbol: false,
};
